import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { confirm } from '../../helpers/helpers';

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';

const RequestedDates = observer(class RequestedDates extends React.Component {
  constructor() {
    super();
    this.confirmDate = this.confirmDate.bind(this);
    this.updateExpiration = this.updateExpiration.bind(this);
    this.rejectDates = this.rejectDates.bind(this);
    this.cancelRequest = this.cancelRequest.bind(this);
  }

  componentWillMount() {
    this.state = {
      confirmationDate: null,
      confirmedDateExpiration: 72
    }
  }

  confirmDate(e, date) {
    const prevSelected = document.querySelector('.thread__dates .selected--alt')

    if(prevSelected) {
      prevSelected.className = prevSelected.className.replace('selected--alt', '');
    }

    e.target.className += ' selected--alt';

    this.setState({
      confirmationDate: moment(date, 'YYYY-MM-DD HH:mm Z').toISOString()
    });
  }

  updateExpiration() {
    this.setState({
      confirmedDateExpiration: this.confirmedDateExpiration.value
    });
  }

  handleDateConfirmation(e) {
    e.preventDefault();

    const data = {
      confirmationDate: this.state.confirmationDate,
      confirmedDateExpiration: this.state.confirmedDateExpiration,
      locationSid: this.props.locationSid
    }

    let callback = null;

    if(this.props.pending) {
      callback = () => {
        this.props.store.ScheduleStore.getPendingSessions('request');
      }
    }

    this.props.store.MessageStore.confirmDate(this.props.messageSid, data, callback);
  }

  rejectDates() {
    const msg = this.props.translation.confirmReject;
    confirm(msg, this.cancelRequest);
  }

  cancelRequest() {
    const datesEl = document.querySelector('.thread__dates');
    this.props.store.MessageStore.cancelRequest(this.props.messageSid, datesEl);
  }

  render() {
    const { translation } = this.props;
    const { threadObject } = this.props.store.MessageStore;
    const _this = this;

    let dates = [];

    if(threadObject.dateOption1) {
      dates.push(threadObject.dateOption1);
    }
    if(threadObject.dateOption2) {
      dates.push(threadObject.dateOption2);
    }
    if(threadObject.dateOption3) {
      dates.push(threadObject.dateOption3);
    }

    if(!threadObject.confirmedDate) {
      return (
        <div className="thread__dates">
          <strong>{translation.requested_dates}</strong>

          <p>
            {translation.requested_dates_helper.replace('%student%', this.props.studentName || translation.this_student)}
          </p>

          <p>
            {translation.requested_dates_note.replace('%student%', this.props.studentName || translation.this_student)}
          </p>

          <ul className="date-opts">
            {dates.map(
              (date, i) =>
              <li key={i}>
                <button
                  className="btn--outline"
                  onClick={(e) => {this.confirmDate(e, date)}}
                  type="button"
                >
                  {moment.utc(date).local().tz(moment.tz.guess()).format('M/D/YYYY [at] h:mma z')}
                </button>
              </li>
            )}
            <li>
              <button
                className="btn--outline btn--negative"
                onClick={this.rejectDates}
                type="button"
              >
                {translation.deny}
              </button>
            </li>
          </ul>

          {this.state.confirmationDate &&
            <form className="thread__confirm form-inline" onSubmit={(e) => {this.handleDateConfirmation(e)}}>
              <fieldset>
                <label htmlFor="date-expires" aria-describedby="expires-tooltip">
                  {translation.expires.label}

                  <div className="tooltip">
                    <span className="tooltip__label">(?)</span>
                    <div id="leadtime-tooltip" className="tooltip__body" role="tooltip">
                      {translation.expires.helper.replace('%expires%', this.state.confirmedDateExpiration)}
                    </div>
                  </div>
                </label>

                <label className="select" htmlFor="date-expires">
                  <select
                    id="date-expires"
                    ref={(input) => {this.confirmedDateExpiration = input}}
                    defaultValue={this.state.confirmedDateExpiration}
                    onChange={this.updateExpiration}
                    required
                    aria-required="true"
                  >
                    <option value={12}>{translation.expires.options.option12}</option>
                    <option value={24}>{translation.expires.options.option24}</option>
                    <option value={48}>{translation.expires.options.option48}</option>
                    <option value={72}>{translation.expires.options.option72}</option>
                  </select>
                </label>
              </fieldset>

              <button className="btn" type="submit">{translation.confirm_date}</button>
            </form>
          }
        </div>
      )
    } else {
      return (
        <div className="thread__dates note">
          <p>
            {translation.confirmed_date}

            <strong>
              {moment.utc(threadObject.confirmedDate).local().tz(moment.tz.guess()).format('M/D/YYYY [at] h:mma z')}
            </strong>
          </p>

          <p>
            {translation.confirmed_date_note.replace(
              '%date%',
              moment.utc(threadObject.confirmedDateExpiration).local().tz(moment.tz.guess()).format('M/D/YYYY [at] h:mma z')
            )}
          </p>
        </div>
      )
    }
  }
})

export default translate('RequestedDates')(RequestedDates);



// WEBPACK FOOTER //
// ./src/app/components/Messages/RequestedDates.js